<template>
<v-form ref="form" @submit.prevent>
  <v-card-text>
    <v-text-field label="請輸入客戶代號" type="text" class="font-weight-bold" autofocus outlined clearable maxlength="10" v-model="myAccountId" :rules="usernameRules" @keyup.enter.prevent="verifyUser"></v-text-field>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-text="'繼續'" color="primary" class="mr-2" @click="verifyUser"></v-btn>
    </v-card-actions>
  </v-card-text>
  </br>
  <!--系統維護公告-->
  <!--<b><font face="微軟正黑體" size="5" color="#FF5252">系統維護中預計於08/15(一) 14:00重新開啟服務，維護期間將暫停相關服務。</font></b></br>-->
  <!--<font face="微軟正黑體" size="3" color="#FF5252">目前還是測試版本</font></br>
  目前版本：beta 0.94 (upd：20220830)</br>-->
</v-form>
</template>

<script>
export default {
  name: "KeyinUser",
  props: ["accountId"],
  data() {
    return {
      dsmid_token: this.$cookie.get('dsmid_token'),
      endsmid_token: this.$cookie.get('endsmid_token'),
      base64en_dsmid_token: this.$cookie.get('base64en_dsmid_token'),
      usernameRules: [
        (v) => !!v || " ",
        //(v) => RegExp(/^[0-9]*$/).test(v) || " ",
        //(v) => this.textFieldError || this.errorMessages,
        (v) => {
          if (!RegExp(/^[0-9 \-#]*$/).test(v)) {
            this.myAccountId = ''
          }
          return true
        },
      ],
    };
  },
  created() { //創建時間節點
    let page_token = 'C';
    this.$cookie.set('page_token', page_token, "0");
  },
  computed: {
    myAccountId: {
      get() {
        return this.accountId;
      },
      set(value) {
        this.$emit("update:accountId", value);
      },
    },
  },
  /*watch: {
    myAccountId(Val) {
      if (!RegExp(/^[0-9]*$/).test(Val)) {
        this.accountId = '';
      }
    },
  },*/
  methods: {
    verifyUser() {
      if (this.$refs.form.validate()) {
        if ((this.myAccountId !== '') && (this.endsmid_token === this.base64en_dsmid_token)) {
          this.$router.push({
            name: "KeyinPswd"
          });
        } else {
          //this.setTextFieldError(false, "客戶代號錯誤");
          alert('客戶代號錯誤');
        }
      }
    },
    /*setTextFieldError(textFieldError, errorMessages) {
      this.textFieldError = textFieldError;
      this.errorMessages = errorMessages;
    },*/
  },
};
</script>
